import React from 'react';
import './Info.less';
import {
  withTextLocalizer,
  formatMmToCm,
  formatKgToTone,
  LocalizePropType,
  DriverCarData,
  isMSM,
  AreaData,
} from 'getaway-data-layer';
import BrandIcon from '../BrandIcon/BrandIcon';
import { carSize } from '../../../assets/brandImages';
import ExpandableItem from '../ExpandableItem/ExpandableItem';
import { padZero, isMobileBrowser } from '../../../utils';

type Props = {
  localize: LocalizePropType;
  selectedCar: DriverCarData;
  fleetStyle: string;
  selectedArea: AreaData;
};

const carSizeImage = {
  spp: '/images/carSizeSPP.png',
  expert: '/images/carSizeOBI.png',
  obi: '/images/carSizeOBI.png',
  bub: '/images/carSizeBUB.png',
};

const Info = ({ localize, selectedCar, fleetStyle, selectedArea }: Props) => {
  const { height, width, length, seats, loadCapacity } = selectedCar;
  const todayOpeningHrs =
    selectedArea?.openingHoursPerDay[
      new Date().getDay() === 0 ? 6 : new Date().getDay() - 1
    ];

  return (
    <div style={{ marginBottom: isMobileBrowser() ? 0 : 65 }}>
      <div className="info-specs">
        <div className="info-spec">
          <BrandIcon name="profileGear" style={{ width: 30, height: 30 }} />
          <div className="info-spec-text">
            {localize(`car.details.gear.${selectedCar.gear}`)}
          </div>
        </div>
        <div className="info-spec">
          <BrandIcon name="profileSeat" style={{ width: 30, height: 30 }} />
          <div className="info-spec-text">{selectedCar.seats}</div>
        </div>
        <div className="info-spec">
          <BrandIcon name="mileage" style={{ width: 30, height: 30 }} />
          <div className="info-spec-text">{`${selectedCar.enginePower} ps`}</div>
        </div>
        <div className="info-spec">
          <BrandIcon name="fuelType" style={{ width: 30, height: 30 }} />
          <div className="info-spec-text">
            {localize(`car.details.fuel.${selectedCar.fuel}`)}
          </div>
        </div>
      </div>
      {!isMSM() && (
        <>
          <div className="info-dimensions-wrapper">
            <img
              className="info-dimensions-img"
              src={carSizeImage?.[fleetStyle] || carSize}
              alt="info-dimensions"
            />
            {height !== 0 && height && (
              <div className="info-height">
                {`${localize('car.details.height')} \n`}
                <div className="info-value">{formatMmToCm(height)}</div>
              </div>
            )}
            {width !== 0 && width && (
              <div className="info-width">
                {`${localize('car.details.width')} \n`}
                <div className="info-value">{formatMmToCm(width)}</div>
              </div>
            )}
            {length !== 0 && length && (
              <div className="info-length">
                {`${localize('car.details.length')} \n`}
                <div className="info-value">{formatMmToCm(length)}</div>
              </div>
            )}
            {loadCapacity !== 0 && loadCapacity && (
              <div className="info-capacity">
                {`${localize('car.details.loadCapacity')} \n`}
                <div className="info-value">{formatKgToTone(loadCapacity)}</div>
              </div>
            )}
            {seats !== 0 && seats && (
              <div className="info-seat">
                <BrandIcon
                  name="profileSeat"
                  style={{ width: 16, height: 16, marginRight: 3 }}
                />
                <div className="info-value">{seats}</div>
              </div>
            )}
          </div>
          <div className="info-footnote">
            {localize('car.profile.dimensions.note')}
          </div>
        </>
      )}

      <div>
        <div className="header-title">{localize('car.profile.area.title')}</div>
        <ExpandableItem
          title={localize('car.profile.area.openinghrs')}
          containerStyles={{
            width: '100%',
            padding: '0 24px 0 24px',
            margin: '24px 0px 24px 0px ',
          }}
          value={
            todayOpeningHrs?.closedWholeDay
              ? localize('closed')
              : `${localize('today')} ${
                  todayOpeningHrs?.closeAtHour
                    ? `${localize('bis')} ${padZero(
                        todayOpeningHrs.closeAtHour
                      )}:${padZero(todayOpeningHrs.closeAtMinute)}`
                    : localize('always.open')
                }`
          }
        >
          <div className="info-areaHrsContent">
            {selectedArea?.openingHoursPerDay.map((day: any) => (
              <div key={day.dayOfWeekCode} className="info-item">
                <p className="info-spec-text">
                  {localize(`day.${day.dayOfWeekCode.toLowerCase()}`)}
                </p>
                <p className="info-value">
                  {day?.closedWholeDay
                    ? localize('closed')
                    : `${padZero(day?.openAtHour)}:${padZero(
                        day.openAtMinute
                      )} bis ${padZero(day.closeAtHour)}:${padZero(
                        day.closeAtMinute
                      )} Uhr`}
                </p>
              </div>
            ))}
          </div>
        </ExpandableItem>
      </div>
      {selectedArea?.note && (
        <>
          <p className="areaNoteTitle">{localize('car.profile.area.note')}</p>
          <p className="areaNote">{selectedArea.note}</p>
        </>
      )}
    </div>
  );
};

export default withTextLocalizer(Info);
